import React from "react";
import ToolStatePanel from "../ToolStatePanel";

export default class ToolErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.retry = this.retry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[NFL tool]", error, info ? info.componentStack : "");
  }

  retry() {
    if (this.props.onRetry) {
      this.props.onRetry();
    }
    this.setState({ error: null });
  }

  render() {
    if (this.state.error) {
      const what = this.props.what || "Stats";
      const wrapError = this.props.wrapError || ((panel) => panel);
      return wrapError(
        <ToolStatePanel
          variant="error"
          title={`${what} didn't load`}
          body="The stats server returned an error. Your filters are kept, so try again in a moment."
          actions={
            <button type="button" className="nfl-btn" onClick={this.retry}>
              Try again
            </button>
          }
        />
      );
    }
    return this.props.children;
  }
}
